export const APP_NAME = 'SALESWORKX'
export const PERSIST_STORE_NAME = 'salesworkx-admin'
export const REDIRECT_URL_KEY = 'redirectUrl'